import { render, staticRenderFns } from "./expert-base.vue?vue&type=template&id=20cf03ea&scoped=true&"
import script from "./expert-base.vue?vue&type=script&lang=js&"
export * from "./expert-base.vue?vue&type=script&lang=js&"
import style0 from "./expert-base.vue?vue&type=style&index=0&id=20cf03ea&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cf03ea",
  null
  
)

export default component.exports